<div class="colored-bubble-action">
    <span class="colored-bubble-icon-circle"
        [ngStyle]="{ 'background-color': color }"
        title="{{title}}" 
        (click)="onBubbleClick($event)"
        ><em class="bubble-letter">{{letter}}</em>
    </span>
</div>
